// export const generateTimestamp = () => {
//     return new Date().toLocaleString();
// };

// export const generateTimestampLocal = () => {
//     return new Date().toLocaleString("en-GB", {
//         hour12: false,
//         year: 'numeric',
//         month: '2-digit',
//         day: '2-digit',
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit'
//     });
// };

export const generateTimestamp = () => {
    return new Date().toISOString();
};
